import { Injectable } from '@angular/core';
import { FeedbackDialogService, QueryViewerMetadata } from '@mode/queries/ai-assist/util';
import { MdcDialogService } from '@mode/shared/ui';
import { SubmitFeedbackDialogComponent } from './submit-feedback-dialog.component';
import { MatDialogRef } from '@angular/material/dialog';
import { SubmitFeedbackFacade } from '@mode/queries/ai-assist/domain';
import { Subscription } from 'rxjs';

@Injectable()
export class SubmitFeedbackDialogService extends FeedbackDialogService {
  constructor(
    private dialogService: MdcDialogService,
    private submitFeedbackFacade: SubmitFeedbackFacade
  ) {
    super();
  }

  public override open(metadata: QueryViewerMetadata) {
    const currentDialog = this.dialogService.open({
      component: SubmitFeedbackDialogComponent,
    });

    this.listenToDialogEvent(currentDialog, metadata);
  }

  private listenToDialogEvent(
    currentDialog: MatDialogRef<SubmitFeedbackDialogComponent>,
    metadata: QueryViewerMetadata
  ) {
    const feedbackSubscription = currentDialog.componentInstance.sendFeedback.subscribe((feedback) => {
      this.sendFeedback(feedback, metadata, feedbackSubscription);
    });
  }

  private sendFeedback(feedback: string, metadata: QueryViewerMetadata, feedbackSubscription: Subscription): void {
    this.submitFeedbackFacade.dispatch(
      SubmitFeedbackFacade.Actions.sendFeedback({
        queryToken: metadata.queryToken,
        metadata,
        feedback,
      })
    );
    feedbackSubscription.unsubscribe();
  }
}
